import './Contacts.scss';

import classnames from 'classnames';
import LinkPhone from 'components/partials/links/components/link-phone/LinkPhone';
import { CONTACTS } from 'config/core';
import _get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { memo, useMemo } from 'react';

const propTypes = {
  className: PropTypes.string
};

const Contacts = ({ className }) => {
  const config = useMemo(() => {
    const { members, agents } = CONTACTS;

    const config = [];

    if (agents.phone) {
      config.push({
        title: 'Speak to an Agent:',
        phone: agents.phone,
        'data-gtm-phone-new-member': true
      });
    }
    if (members.phone) {
      config.push({
        title: 'Current members:',
        phone: members.phone,
        'data-gtm-phone-existing-member': true
      });
    }

    return config;
  }, []);

  const agentsEmail = _get(CONTACTS, 'agents.email');

  return (
    <div className={classnames('contacts', className)}>
      <span className="contact">
        Email us: {''}
        <a data-gtm-email-agents-link href={`mailto:${agentsEmail}`}>
          {agentsEmail}
        </a>
      </span>
      {config.map(({ title, phone, ...args }, idx) => {
        return (
          <span key={idx} className="contact">
            <em>{title}</em> <LinkPhone {...args} to={phone} />
          </span>
        );
      })}
    </div>
  );
};

Contacts.propTypes = propTypes;

export default memo(Contacts);
